import useController from './useController'

export default useController
